import { Popover } from 'antd';
import { StyledTranslationPopoverContent } from './TranslationPopover.styled';
import Colors from '@/constants/Colors';

export default function TranslationPopover({
  element,
  word,
  translation,
  onClose,
}) {
  return (
    element && (
      <Popover
        arrowPointAtCenter
        zIndex={999999999}
        trigger="click"
        color={Colors.lightBlue}
        content={
          <StyledTranslationPopoverContent>
            {/* <div className="word">{word}</div> */}
            <div className="translation">{translation}</div>
          </StyledTranslationPopoverContent>
        }
        visible
        onVisibleChange={(visible) => {
          onClose();
        }}
        placement="bottom"
      >
        <span
          className="popover-trigger"
          style={{
            position: 'fixed',
            ...getPopoverPosition(element),
          }}
        />
      </Popover>
    )
  );
}

function getPopoverPosition(target) {
  const rect = target.getBoundingClientRect();
  return {
    left: rect.left,
    top: rect.top - 15,
    width: rect.width,
    height: rect.height,
  };
}
